/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
    addTicket,
    editTicket,
    getTickets
} from "../../api/apiCall";
import { useAuth } from "../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";

const Tickets = () => {
    const {state} = useAuth();
    const [tickets, setTickets] = useState<any>([]);
    const handleAddRow = () => {
        const newRow = {
            id: tickets.length + 1,
            name: ``
        };
        setTickets((prevRows: any) => [newRow, ...prevRows]);
    };

    const handleChange = (id: any, field: any, newValue: any) => {
        const updatedRows = tickets.map((row: any) =>
          row.id === id ? { ...row, [field]: newValue } : row
        );
        setTickets(updatedRows);
    };

    const columns: any = [
        {
            field: "ticketName",
            headerName: "Tickets",
            flex: 0.8,
            renderCell: (params: any) => (
                <TextField
                    size="small"
                    value={params.row.ticketName}
                    fullWidth
                    style={{ height: "5px", margin: 5 }}
                    onChange={(event: any) => {
                        handleChange(params.id, "ticketName", event.target.value);
                    }}
                    inputProps={{
                        ...params.inputProps,
                        onKeyDown: (event) => {
                            if (event.key === ' ') {
                                event.stopPropagation();
                            }
                        },
                    }}
                />
              ),
        },
        {
            field: "createdDate",
            headerName: "Added Date",
            align: 'center',
            headerAlign: 'center',
            flex: 0.5,
            renderCell: (params: any) => (
                <div>
                    {format(new Date(params.row.createdDate || Date.now()), 'dd/MM/yyyy')}
                </div>
            ),
        },
        {
            field: "save",
            headerName: "Save",
            flex: 0.3,
            renderCell: (params: any) => (
                <Button variant="outlined" onClick={()=> handleCellEditCommit(params)}>Save</Button>
            )
        }
    ];

    const handleCellEditCommit = async (params: any) => {
        if(typeof params.row.id === 'number') {
            const response = await addTicket(state.user?.token, params.row.ticketName)
            if(response) {
                toast.success('Added ticket successfully');
                getTickets(state.user?.token).then(setTickets);
            } else {
                toast.error('Something went wrong!')
            }
        } else {
            const response = await editTicket(state.user?.token, params.row.id, params.row.ticketName);
            if(response) {
                toast.success('Ticket updated successfully');
            } else {
                toast.error('Something went wrong!')
            }
        }
    };

    useEffect(() => {
        getTickets(state.user?.token).then(setTickets);
    }, [])

    return (
        <div>
            <div className="add-button">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddRow}
                    style={{boxShadow: 'none'}}
                >
                    Add Ticket
                </Button>
            </div>
            <Box
                sx={{
                    width: "60%",
                    height: '840px',
                    margin: "0 auto",
                    mt: 4,
                    "@media (max-width: 800px)": {
                        overflowX: "auto",
                        margin: 1,
                        minWidth: "95%",
                    },
                }}
            >
                <DataGrid
                    rows={tickets}
                    columns={columns}
                    disableRowSelectionOnClick
                    sx={{
                        "@media (max-width: 700px)": {
                            minWidth: "100%",
                        },
                        "& .MuiDataGrid-columnHeader": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15,
                            backgroundColor: '#f0f0f0',
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                        },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "#f1f1f1",
                        },
                    }}
                />
            </Box>
        </div>
    );
};

export default Tickets;
